module.exports = __webpack_public_path__ + "img/zapier-logo.218e59d1.svg";